import React, { useEffect, useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import { useSelector } from 'react-redux';
import { AssignmentTabIndex } from '../../utils/typeConstants';
import { CaDashboard } from '../../features/correctiveActions/dashboardCorrectiveAction/CaDashboard';
import { CaMangerTl } from '../../features/correctiveActions/managerTlViewSearch/CaMangerTlView';
import { caDetails } from '../../features/correctiveActions/type';
import { ROLES } from '../../constants';
import { selectCurrentUserManagerLevel, selectCurrentIsHC, selectIsPseudoSupervisor, selectCurrentEmpid } from '../../pages/login/authSlice';
import { useGetCaManagerTlSearchQuery } from '../../features/correctiveActions/managerTlViewSearch/CaMangerTLView.slice';
import { datetimeToDate, dateType } from '../../utils/dateFormat';

interface CorrectiveActionsAssignmentProps {
    source?:             string;
    employeeNumber?:      string;
    coachingActionPlanId?: number;
    scorecardVersionId?:  number;
    correctiveActionId?:  number;
    correctiveActionDate?: dateType;
}

export const CorrectiveActionsAssignment: React.FC<CorrectiveActionsAssignmentProps> = ({
    source,
    employeeNumber,
    coachingActionPlanId,
    scorecardVersionId,
    correctiveActionId,
    correctiveActionDate,
}) => {
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const isHC = useSelector(selectCurrentIsHC);
    const isPseudoSupervisor=useSelector(selectIsPseudoSupervisor);

    // Open Assignment tab directly if coming from Action Plan, otherwise Dashboard
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [selectedEmployee, setSelectedEmployee] = useState<caDetails | undefined>();
    const [via, setVia] = useState<string>((source === 'cap' || source === 'actionplans') ? 'corrective' : 'tab');    
        const loggedEmpNum = useSelector(selectCurrentEmpid);
    const resetFilter = () => {
        window.localStorage.removeItem('country');
        window.localStorage.removeItem('category');
        window.localStorage.removeItem('role');
    };

    // eslint-disable-next-line camelcase
    const prefilledEmployee: caDetails | undefined = source === 'cap' && employeeNumber
        // eslint-disable-next-line camelcase
        ? { employee_number: employeeNumber} as unknown as caDetails
        : undefined;
    const { data: caMangerTlDataSlice } = useGetCaManagerTlSearchQuery(
            {
                employeeNumber,
                isCurrentTeam: undefined,
                isApprovals: false,
                CreationStartDate: correctiveActionDate ? datetimeToDate(correctiveActionDate) : '',
                CreationEndDate: correctiveActionDate ? datetimeToDate(correctiveActionDate) : '',
            },
            { skip: !loggedEmpNum||source !== 'actionplans' }
        );
    useEffect(() => {
        if (source === 'cap') {
            setActiveIndex(AssignmentTabIndex.Assignment);
        }
        else if (source === 'actionplans') {
            if(caMangerTlDataSlice && caMangerTlDataSlice.data.length > 0){
            const selectedEmployee = caMangerTlDataSlice?.data?.find((item: any) => item.corrective_action_id === correctiveActionId);
            setSelectedEmployee(selectedEmployee);
            setActiveIndex(AssignmentTabIndex.View);
        }            
        }
        else {
            setActiveIndex(AssignmentTabIndex.Dashboard);
        }
    }, [source,caMangerTlDataSlice]);

    return (
        <div>
            
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <TabView
                                activeIndex={activeIndex}
                                onTabChange={(e) => {
                                    if (e.index === 0) resetFilter();
                                    if (e.index === 1) setVia('tab');
                                    setSelectedEmployee(undefined);
                                    setActiveIndex(e.index);
                                }}
                            >
                                <TabPanel header="Dashboard">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <CaDashboard
                                                fromPage="CorrectiveActionsAssignment"
                                                setVia={setVia}
                                                setSelectedEmployee={setSelectedEmployee}
                                                setActiveIndex={setActiveIndex}
                                            />
                                        </div>
                                    </div>
                                </TabPanel>

                                {(isHC || ROLES.SupervisorOrOnlyManager.includes(userManagerLevel) || isPseudoSupervisor === true) &&
                                <TabPanel header="Assignment">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                                <CaMangerTl
                                                    setActiveIndex={setActiveIndex}
                                                    type="add"
                                                    getDetails={false}
                                                    via={via}
                                                    selectedEmployee={prefilledEmployee ?? selectedEmployee}
                                                    view={false}
                                                    fromCAP={source === 'cap'}
                                                    coachingActionPlanId={coachingActionPlanId}
                                                    scorecardVersionId={scorecardVersionId}
                                                />
                                        </div>
                                    </div>
                                </TabPanel>}

                                {activeIndex === AssignmentTabIndex.View &&
                                <TabPanel header="View">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <CaMangerTl setActiveIndex={setActiveIndex} type="view" getDetails selectedEmployee={selectedEmployee} view />
                                        </div>
                                    </div>
                                </TabPanel>}

                                {activeIndex === AssignmentTabIndex.Updates &&
                                <TabPanel header="Update">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <CaMangerTl setActiveIndex={setActiveIndex} type="update" getDetails via={via} selectedEmployee={selectedEmployee} view={false} />
                                        </div>
                                    </div>
                                </TabPanel>}
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
